import { QuotationConstant, QuotationRequiredFieldList } from "presentation/constant/QuotationSetting/QuotationConstant";
import { useQuotationVM } from "presentation/hook/QuotationSetting/useQuotationVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useQuotationTracked } from "presentation/store/QuotationSetting/QuotationProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, HPHInputMask, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const QuotationEditPanel = () => {
    const SCREEN_CONSTANT = QuotationConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [quotationState] = useQuotationTracked();
    const quotationVM = useQuotationVM();
    const { currentEditRow, isAdd, isEdit, masterState } = quotationState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;



    const handleSave = useCallback(async () => {
        // if (!currentEditRow.consortiumCode || !currentEditRow.vesselCode || !currentEditRow.voyageCode) {
        //     messageBarVM.showError("Co/Vsl/Voy is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.etd) {
        //     messageBarVM.showError("ETD is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.quotationNo) {
        //     messageBarVM.showError("Quotation No is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.quotationDesc) {
        //     messageBarVM.showError("Quotation Desc is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.quotationAmount) {
        //     messageBarVM.showError("Quotation Amount is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        quotationVM.onSaveClicked();
        await quotationVM.onSave(currentEditRow).then(data => {
            if (data && data.success) {
                quotationVM.onSearch().then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                data.data && messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, messageBarVM, quotationVM]);

    const handClose = useCallback(() => {
        quotationVM.onCloseEidtPanel();
    }, [quotationVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        quotationVM.onFieldChange(fieldName, fieldValue);
    }, [quotationVM]);

    const memoCoVslVoy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <HPHInputMask
                label={SCREEN_CONSTANT.CO_VSL_VOY}
                width={'450px'}
                errorMessage={allFormState ? (allFormState["consortiumCode"] ? allFormState["consortiumCode"] : (allFormState["vesselCode"] ? allFormState["vesselCode"] : (allFormState["voyageCode"] ? allFormState["voyageCode"] : ""))) : ""}
                disabled={!(isAdd || isEdit)}
                value={{
                    co: currentEditRow?.consortiumCode ?? '',
                    vsl: currentEditRow?.vesselCode ?? '',
                    voy: currentEditRow?.voyageCode ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 6, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => quotationVM.onCoVslVoyChange(e, {
                    co: 'consortiumCode',
                    vsl: 'vesselCode',
                    voy: 'voyageCode'
                })} />
        </div>
        , [SCREEN_CONSTANT.CO_VSL_VOY, allFormState, currentEditRow?.consortiumCode, currentEditRow?.vesselCode, currentEditRow?.voyageCode, isAdd, isEdit, quotationVM])

    const memoEtd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={!(isAdd || isEdit)}
                label={SCREEN_CONSTANT.ETD}
                width="450px"
                date={currentEditRow?.etd}
                fieldName="etd"
                errorMessage={allFormState ? allFormState["etd"] ?? "" : ""}
                onDateChange={quotationVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.ETD, allFormState, currentEditRow?.etd, isAdd, isEdit, quotationVM.onFieldChange])


    const memoQuotationNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.quotationNo ?? ""}
                fieldValue={currentEditRow?.quotationNo ?? []}
                fieldLabel={SCREEN_CONSTANT.QUOTATION_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'quotationNo'}
                maxLength={15}
                isMultipleDropDown={true}
                requiredFieldList={QuotationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    quotationVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.QUOTATION_NO, allFormState, currentEditRow.quotationNo, isAdd, isEdit, isSaveClicked, quotationVM])

    const memoQuotationAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.QUOTATION_AMOUNT}
                maxLength={13}
                fieldName={"quotationAmount"}
                value={currentEditRow?.quotationAmount || ''}
                errorMessage={allFormState ? allFormState["quotationAmount"] ?? "" : ""}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.QUOTATION_AMOUNT, allFormState, currentEditRow?.quotationAmount, isAdd, isEdit, onNumberFieldChange])


    const memoQuotationDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.quotationDesc ?? ""}
                fieldValue={currentEditRow?.quotationDesc ?? []}
                fieldLabel={SCREEN_CONSTANT.QUOTATION_DESC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'quotationDesc'}
                maxLength={100}
                isMultipleDropDown={true}
                requiredFieldList={QuotationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    quotationVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.QUOTATION_DESC, allFormState, currentEditRow.quotationDesc, isAdd, isEdit, isSaveClicked, quotationVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "450px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={QuotationRequiredFieldList}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => quotationVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEditRow?.activeInd, isAdd, isEdit, quotationVM])

    const handleEdit = useCallback(() => {
        quotationVM.onEditClick();
    }, [quotationVM]);

    const handleReset = useCallback(() => {
        quotationVM.onResetClick(isAdd);
    }, [quotationVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Quotation"}
                                    {/* {!isAdd && "Edit Quotation"} */}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoCoVslVoy}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoEtd}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoQuotationNo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoQuotationDesc}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoQuotationAmount}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default QuotationEditPanel;
